import { z } from 'zod';

export namespace GetTherapeuticAreas {
  export const Schema = {
    Query: z.object({
      q: z.string().optional(),
    }),
    Response: z.object({
      items: z.array(
        z.object({
          id: z.uuid(),
          name: z.string(),
          displayName: z.string().nullable(),
        })
      ),
    }),
  };

  export type Request = z.infer<typeof Schema.Query>;
  export type Response = z.infer<typeof Schema.Response>;
}

export namespace CreateTherapeuticArea {
  export const Schema = {
    Body: z.object({
      name: z.string().trim().min(1),
      displayName: z.string().trim().min(1).optional(),
    }),
    Response: z.object({
      id: z.uuid(),
      name: z.string(),
      displayName: z.string().nullable(),
    }),
  };

  export type Request = z.infer<typeof Schema.Body>;
  export type Response = z.infer<typeof Schema.Response>;
}
